import React from 'react';

function BrandMark({ className = '', alt = 'GHOST Logo' }) {
  return (
    <img
      className={className}
      src="/images/yl-logo-mark.png"
      alt={alt}
    />
  );
}

export default BrandMark;
